import { useCallback } from 'react';
import { useRouter } from 'expo-router';
import { Platform } from 'react-native';

import { useFeatureFlag } from '@order/LaunchDarkly';

export const useScanToPayNavigation = (closeModal: () => void) => {
  const router = useRouter();
  const isLoyaltyUpdatesEnabled = useFeatureFlag('CELS-5711-order-loyalty-updates-enabled');

  const goToSgRewards = useCallback(() => {
    closeModal();

    router.dismissTo(isLoyaltyUpdatesEnabled ? '/loyalty' : '/rewards');
  }, [closeModal, isLoyaltyUpdatesEnabled, router]);

  const goToForgotToScan = useCallback(() => {
    closeModal();

    router.navigate('/forgot-to-scan');
  }, [closeModal, router]);

  const goToSupport = useCallback(() => {
    closeModal();

    router.navigate('/chat');
  }, [closeModal, router]);

  const goToPayments = useCallback(() => {
    closeModal();

    router.navigate({
      pathname: '/payments',
      params: { redirectTo: `https://${host}/scan-at-checkout` },
    });
  }, [closeModal, router]);

  const goBack = useCallback(() => {
    closeModal();

    router.back();
  }, [closeModal, router]);

  return {
    goToSgRewards,
    goToForgotToScan,
    goToSupport,
    goToPayments,
    goBack,
  };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const host = Platform.select({
  web: window.location.host,
  default: 'order.sweetgreen.com',
});
